import {Button, Card, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import AdhocImageUpload from "../AdhocImageUpload";
import AdhocImageGallary from "../AdhocImageGallary";
import {getCheckList} from "../../service/JobService";

export function CheckListModel({show, job, handleClose, fieldSupervisorMap, fieldWorkerMap}) {
    const [checkLists, setCheckLists] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const refreshCheckList = () => {

        setIsLoading(true);
        getCheckList(job.cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    setCheckLists(data);
                });
            } else {
                //If no instruction is found, no error, just
            }
        }).finally(() => setIsLoading(false));

    };

    useEffect(() => {
        refreshCheckList();
    }, [job]);

    return (

        <Modal show={show} onHide={handleClose}
               onClick={(e) => e.stopPropagation()}>
            <Modal.Header closeButton>
                <Modal.Title>Job Checklist - {job.cos_job_id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <strong>Full Address:</strong> {job.full_address}<br/>
                    <strong>Date:</strong> {new Date(job.date).toLocaleDateString()}<br/>
                    <strong>Worker Name:</strong> {fieldWorkerMap[job.cos_job_worker]}<br/>
                    <strong>Supervisor Name:</strong> {fieldSupervisorMap[job.cos_job_supervisor]}<br/>
                    <strong>Job Score:</strong> {job.score}<br/>
                </div>
                {checkLists && checkLists.map((item, index) => (
                    <Card key={index} className="mb-3">
                        <Card.Header><b>{item.category}</b></Card.Header>
                        <Card.Body>
                            <Card.Text>{item.description}</Card.Text>
                            <div style={{marginLeft: 20, marginRight: 20}}>
                                <AdhocImageGallary images={item.images}
                                                   setImages={() => {
                                                   }}
                                                   isReadOnly={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                ))}
                <div style={{marginLeft: 20, marginRight: 20}}>
                    <AdhocImageGallary images={checkLists.images || []}
                                       setImages={(images) => setCheckLists({...checkLists, images})}/>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" disabled={isLoading} onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>

    );
}
